import { useState, useEffect } from 'react';
import { Modal, Button, Form, Input, message, Divider, Select } from 'antd';
import { NumericFormat } from 'react-number-format';
import axios from "./../../../services/http";
const { Option } = Select;

const ModalAddPending = ({ 
    obra, builders, title, editBand, 
    typePending, openPendingDialog, 
    cancelPendingDialog, setOpenDialogContratista,
    fetchPPR, pendingForRelationship
}) => {

    const [pendingForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [selectedBuilder, setSelectedBuiler] = useState();
    const [cp, setCp] = useState([]);
    const [disabledIVA, setDisabledIVA] = useState(false);
    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});

    useEffect(() => {
        pendingForm.resetFields();
        setSelectedBuiler();
        if (editBand === "update" && pendingForRelationship) SetPendingForRelationship();
        
    }, [editBand, pendingForRelationship]);

    const SetPendingForRelationship = () => {
        setSelectedBuiler(pendingForRelationship.contratista_id)
        pendingForm.setFieldsValue({
            id: pendingForRelationship.id,
            concepto: pendingForRelationship.concepto,
            id_pendiente: pendingForRelationship.id_pendiente,
            contratista_id: pendingForRelationship.contratista_id,
            total: pendingForRelationship.total,
            contratoFiscal: pendingForRelationship.contratoFiscal,
            contratoNoFiscal: pendingForRelationship.contratoNoFiscal,
            registradoFiscal: pendingForRelationship.registradoFiscal,
            registradoNoFiscal: pendingForRelationship.registradoNoFiscal,
            iva: pendingForRelationship.iva
        });
    }

    const fetchCP = async (contratistaId) => {
        setLoading(true);
        try {
            let data = [];
            const response = await axios.HTTP_GET(`/api/v1/catalogs/controlesdepago/${obra.id}/${contratistaId}`);
            if (response){
                data = response;
                setCp(data);
            }

        } catch (error) {
            console.error('Error al obtener los controles de pago:', error);
            message.error('Error al obtener los controles de pago');
            setCp([]);
        } finally {
            setLoading(false);
        }
    };

    const handleBuilderChange = (value) => {
        const contratistaId = value;
        setSelectedBuiler(contratistaId);
        fetchCP(contratistaId);
    };

    const onValuesChange = (changedValues) => {
        if ('contratoFiscal' in changedValues) {
            let contratoFiscal = changedValues.contratoFiscal;
            if (typeof contratoFiscal === "string") {
                contratoFiscal = parseFloat(contratoFiscal.replace(/[$,]/g,'')).toFixed(2);
                if (contratoFiscal === "0.00") setDisabledIVA(true);
                else setDisabledIVA(false);
            }
        }
    };

    const handlePending = async (values) => {
        if (editBand === "create") handlePendientes(values);
        else handlePendingUpdate(values);
    }

    const ReplaceNumberFormat = (values) => {
        return {
            total: (typeof values.total === "string" ? parseFloat(values.total.replace(/[^0-9.-]/g, '')).toFixed(2) : values.total),
            iva: (typeof values.iva === "string" ? parseFloat(values.iva).toFixed(2) : (values.iva === null || values.iva === undefined ? 0 : values.iva)),
            contratoFiscal: (typeof values.contratoFiscal === "string" ? parseFloat(values.contratoFiscal.replace(/[^0-9.-]/g, '')).toFixed(2) : values.contratoFiscal),
            contratoNoFiscal: (typeof values.contratoNoFiscal === "string" ? parseFloat(values.contratoNoFiscal.replace(/[^0-9.-]/g, '')).toFixed(2) : values.contratoNoFiscal),
            registradoFiscal: (typeof values.registradoFiscal === "string" ? parseFloat(values.registradoFiscal.replace(/[^0-9.-]/g, '')).toFixed(2) : values.registradoFiscal),
            registradoNoFiscal: (typeof values.registradoNoFiscal === "string" ? parseFloat(values.registradoNoFiscal.replace(/[^0-9.-]/g, '')).toFixed(2) : values.registradoNoFiscal),
        }
    }

    const handlePendientes = async (values) => {
        const nuevoPendienteRelacionar = {
            obra_id: obra.id,
            obra_nombre: obra.nombre_obra,
            concepto: values.concepto,
            id_pendiente: values.id_pendiente,
            contratista_id: values.contratista_id,
            tipo: "PENDIENTE",
            ...ReplaceNumberFormat(values)
        };

        const response = await axios.HTTP_POST("/api/v1/payments/pendingToRelationship/save", nuevoPendienteRelacionar);
        if (response) {
            cancelPendingDialog(false);
            message.success(response.data.message);
            fetchPPR();
        }
    }

    const handlePendingUpdate = async (values) => {
        const pendingForRelationship = {
            id: pendingForm.getFieldValue("id"),
            obra_id: obra.id,
            obra_nombre: obra.nombre_obra,
            concepto: values.concepto,
            id_pendiente: values.id_pendiente,
            contratista_id: values.contratista_id,
            tipo: "PENDIENTE",
            ...ReplaceNumberFormat(values)
        };

        const response = await axios.HTTP_POST("/api/v1/payments/pendingToRelationship/update", pendingForRelationship);
        if (response) {
            cancelPendingDialog(false);
            message.success(response.data.message);
            fetchPPR();
        }
    }

    return (
        <>
            <Modal
                title={title}
                open={openPendingDialog}
                onCancel={() => cancelPendingDialog(false)}
                footer={null}
                >
                <Divider style={{ margin: '24px 0' }} />
                <Form
                    layout="vertical"
                    form={pendingForm}
                    onFinish={handlePending}
                    onValuesChange={onValuesChange}
                >
                    <Form.Item
                        label="Contratista"
                        name="contratista_id"
                        rules={[{ required: true, message: 'Por favor seleccionar el contratista' }]}
                    >
                        <Select
                        placeholder="Seleccionar Contratista"
                        value={selectedBuilder || undefined}
                        onChange={handleBuilderChange}
                        style={{ width: '100%' }}
                        loading={loading}
                        dropdownRender={(menu) => (
                        <>
                        {menu}
                        <Button type="link" onClick={() => setOpenDialogContratista(true)}>
                            Nuevo contratista
                        </Button>
                        </>
                        )}
                        >
                        {builders.map((contratista) => (
                            <Option key={contratista.id} value={contratista.id}>
                            {contratista.nombre_contratista}
                            </Option>
                        ))}
                        </Select>
                    </Form.Item>

                    {selectedBuilder && (
                        <>
                            <Form.Item
                                label="Concepto"
                                name="concepto"
                                rules={[{ required: true, message: 'Por favor ingresar el concepto' }]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="ID"
                                name="id_pendiente"
                                rules={[{ required: true, message: 'Por favor ingresar el id' }]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Total"
                                name="total"
                                rules={[{ required: true, message: 'Por favor ingresar el total' }]}
                            >
                                <NumericFormat 
                                    thousandSeparator={true} prefix={'$ '} 
                                    customInput={Input}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Contrato Fiscal"
                                name="contratoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el contrato fiscal' }]}
                            >
                                <NumericFormat 
                                    thousandSeparator={true} prefix={'$ '} 
                                    customInput={Input}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Contrato No Fiscal"
                                name="contratoNoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el contrato no fiscal' }]}
                            >
                                <NumericFormat 
                                    thousandSeparator={true} prefix={'$ '} 
                                    customInput={Input}
                                />
                            </Form.Item>
                            {!disabledIVA?
                                <Form.Item
                                    label="IVA"
                                    name="iva"
                                    rules={[{ required: true, message: 'Por favor selecciona el IVA' }]}
                                >
                                    <Select placeholder="Selecciona una opción" disabled={disabledIVA}>
                                        <Select.Option value={8}>8%</Select.Option>
                                        <Select.Option value={16}>16%</Select.Option>
                                    </Select>
                                </Form.Item>
                            :null}
                            <Form.Item
                                label="Registrado Fiscal"
                                name="registradoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el registrado fiscal' }]}
                            >
                                <NumericFormat 
                                    thousandSeparator={true} prefix={'$ '} 
                                    customInput={Input}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Registrado No Fiscal"
                                name="registradoNoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el registrado no fiscal' }]}
                            >
                                <NumericFormat 
                                    thousandSeparator={true} prefix={'$ '} 
                                    customInput={Input}
                                />
                            </Form.Item>
                        </>
                    )}

                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            <Button type="default" onClick={() => cancelPendingDialog(false)}>
                                Cancelar
                            </Button>
                            <Button type="primary" loading={loading} htmlType="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModalAddPending;